import React from 'react'
import { Flex, Text } from 'theme-ui'

export const MondayOption = ({ label }) => (
  <Flex>
    <Text sx={{ ml: 2 }}>{label}</Text>
  </Flex>
)
